import { lazy } from 'react';

const StaffConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: '/users',
      component: lazy(() => import('./StaffApp')),
    },
    
  ],
};

export default StaffConfig;
